import { s } from '../lib/style.js';

export function Team({ v }) {
  return (
    <section id="team" style={s("scroll-margin-top:80px;background:var(--paper);color:var(--navy);")}>
      <div
        style={s("max-width:1220px;margin:0 auto;padding:clamp(28px,3vw,44px) clamp(20px,4vw,28px) clamp(40px,5vw,64px);")}
      >
        <div style={s("text-align:center;max-width:720px;margin:0 auto;")}>
          <div
            style={s("display:inline-flex;align-items:center;margin-bottom:18px;padding:9px 20px;border-radius:999px;background:#FFFFFF;border:1px solid rgba(18,49,56,0.12);box-shadow:0 2px 10px rgba(18,49,56,0.06);font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
          >
            The leadership team
          </div>
          <h2
            style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(30px,4vw,50px);line-height:1.08;letter-spacing:-0.03em;margin:0;color:var(--navy);")}
          >
            Building it with a
            {' '}
            <span style={s(v.kwLight)}>
              redemptive vision.
            </span>
          </h2>
          <p style={s("margin:18px 0 0;font-size:18px;line-height:1.6;color:var(--paper-muted);")}>
            AI should not replace teams. AI should be designed to enable teams to flourish.
          </p>
        </div>
        <div
          style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(240px,100%),1fr));gap:18px;margin-top:clamp(44px,5vw,62px);align-items:stretch;")}
        >
          <div
            className="hv-14"
            onMouseEnter={v.teamOn1}
            onMouseLeave={v.teamOff}
            onClick={v.teamOn1}
            style={s("min-width:0;position:relative;z-index:1;height:100%;border-radius:20px;border:1px solid var(--paper-line);background:#FFFFFF;text-align:left;display:flex;flex-direction:column;transition:box-shadow .3s ease,border-color .3s ease;")}
          >
            <div
              style={s("position:relative;aspect-ratio:4/5;background:#E6EBE8;border-radius:19px 19px 0 0;overflow:hidden;")}
            >
              {' '}
              <img
                src="/assets/team-jeff-thompson.webp"
                alt="Jeff Thompson"
                style={s("position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;filter:grayscale(1) contrast(1.04);")}
              />
              {' '}
              <div
                style={s("position:absolute;inset:auto 0 0 0;padding:20px;background:linear-gradient(180deg,rgba(18,49,56,0) 0%,rgba(18,49,56,0.82) 68%);")}
              >
                <div
                  style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:23px;letter-spacing:-0.025em;color:#FFFFFF;")}
                >
                  Jeff Thompson
                </div>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:14px;letter-spacing:0.08em;text-transform:uppercase;color:#9EDBD1;margin-top:7px;")}
                >
                  Founder & CEO
                </div>
              </div>
            </div>
            <div style={s("padding:20px;flex:1;display:flex;flex-direction:column;")}>
              <div style={s("position:relative;")}>
                <p style={s("margin:0;font-size:15px;line-height:1.6;color:var(--paper-muted);")}>
                  A former CMO, SVP & GM with 20+ years in CPG at P&G, Johnson & Johnson, Clorox, and Tropicana Brands Group (PepsiCo & PAI PE).
                </p>
                <div
                  style={s(`position:absolute;top:100%;left:-21px;right:-21px;margin-top:10px;background:#FFFFFF;border:1px solid rgba(46,122,114,0.35);border-top:none;border-radius:0 0 20px 20px;box-shadow:0 22px 44px rgba(18,49,56,0.12);overflow:hidden;transition:max-height .45s cubic-bezier(.4,0,.2,1),opacity .3s ease;max-height:${v.bioMax1 ?? ""};opacity:${v.bioOp1 ?? ""};`)}
                >
                  <p
                    style={s("margin:0;padding:0 20px 20px;font-size:15px;line-height:1.6;color:var(--paper-muted);")}
                  >
                    Jeff brings decades of experience in how CPG companies and brand teams work and how AI can be an enabler of helping teams thrive.
                  </p>
                </div>
              </div>
              <div
                style={s(`display:flex;align-items:center;gap:6px;margin-top:auto;overflow:hidden;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--paper-muted);transition:max-height .35s cubic-bezier(.4,0,.2,1),opacity .25s ease,padding-top .35s cubic-bezier(.4,0,.2,1);max-height:${v.cueH1 ?? ""};padding-top:${v.cuePad1 ?? ""};opacity:${v.cueOp1 ?? ""};`)}
              >
                {' '}
                <span>
                  {v.cueLabel1}
                </span>
                {' '}
                <span
                  style={s(`display:inline-block;transition:transform .35s ease;transform:${v.cueRot1 ?? ""};`)}
                >
                  ↓
                </span>
                {' '}
              </div>
            </div>
          </div>
          <div
            className="hv-14"
            onMouseEnter={v.teamOn2}
            onMouseLeave={v.teamOff}
            onClick={v.teamOn2}
            style={s("min-width:0;position:relative;z-index:1;height:100%;border-radius:20px;border:1px solid var(--paper-line);background:#FFFFFF;text-align:left;display:flex;flex-direction:column;transition:box-shadow .3s ease,border-color .3s ease;")}
          >
            <div
              style={s("position:relative;aspect-ratio:4/5;background:#E6EBE8;border-radius:19px 19px 0 0;overflow:hidden;")}
            >
              {' '}
              <img
                src="/assets/team-mark-sears.webp"
                alt="Mark Sears"
                style={s("position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;filter:grayscale(1) contrast(1.04);")}
              />
              {' '}
              <div
                style={s("position:absolute;inset:auto 0 0 0;padding:20px;background:linear-gradient(180deg,rgba(18,49,56,0) 0%,rgba(18,49,56,0.82) 68%);")}
              >
                <div
                  style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:23px;letter-spacing:-0.025em;color:#FFFFFF;")}
                >
                  Mark Sears
                </div>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:14px;letter-spacing:0.08em;text-transform:uppercase;color:#9EDBD1;margin-top:7px;")}
                >
                  Co-Founder & CTO
                </div>
              </div>
            </div>
            <div style={s("padding:20px;flex:1;display:flex;flex-direction:column;")}>
              <div style={s("position:relative;")}>
                <p style={s("margin:0;font-size:15px;line-height:1.6;color:var(--paper-muted);")}>
                  Founder of CloudFactory, which he scaled from zero to $50M with a global team of 7,000 serving 200+ companies building AI.
                </p>
                <div
                  style={s(`position:absolute;top:100%;left:-21px;right:-21px;margin-top:10px;background:#FFFFFF;border:1px solid rgba(46,122,114,0.35);border-top:none;border-radius:0 0 20px 20px;box-shadow:0 22px 44px rgba(18,49,56,0.12);overflow:hidden;transition:max-height .45s cubic-bezier(.4,0,.2,1),opacity .3s ease;max-height:${v.bioMax2 ?? ""};opacity:${v.bioOp2 ?? ""};`)}
                >
                  <p
                    style={s("margin:0;padding:0 20px 20px;font-size:15px;line-height:1.6;color:var(--paper-muted);")}
                  >
                    Mark brings two decades of entrepreneurship, product, platform, and AI experience to lead the agentic foundation beneath BrandBase.
                  </p>
                </div>
              </div>
              <div
                style={s(`display:flex;align-items:center;gap:6px;margin-top:auto;overflow:hidden;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--paper-muted);transition:max-height .35s cubic-bezier(.4,0,.2,1),opacity .25s ease,padding-top .35s cubic-bezier(.4,0,.2,1);max-height:${v.cueH2 ?? ""};padding-top:${v.cuePad2 ?? ""};opacity:${v.cueOp2 ?? ""};`)}
              >
                {' '}
                <span>
                  {v.cueLabel2}
                </span>
                {' '}
                <span
                  style={s(`display:inline-block;transition:transform .35s ease;transform:${v.cueRot2 ?? ""};`)}
                >
                  ↓
                </span>
                {' '}
              </div>
            </div>
          </div>
          <div
            className="hv-14"
            onMouseEnter={v.teamOn3}
            onMouseLeave={v.teamOff}
            onClick={v.teamOn3}
            style={s("min-width:0;position:relative;z-index:1;height:100%;border-radius:20px;border:1px solid var(--paper-line);background:#FFFFFF;text-align:left;display:flex;flex-direction:column;transition:box-shadow .3s ease,border-color .3s ease;")}
          >
            <div
              style={s("position:relative;aspect-ratio:4/5;background:#E6EBE8;border-radius:19px 19px 0 0;overflow:hidden;")}
            >
              {' '}
              <img
                src="/assets/team-cary-smith.webp"
                alt="Cary Smith"
                style={s("position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;filter:grayscale(1) contrast(1.04);")}
              />
              {' '}
              <div
                style={s("position:absolute;inset:auto 0 0 0;padding:20px;background:linear-gradient(180deg,rgba(18,49,56,0) 0%,rgba(18,49,56,0.82) 68%);")}
              >
                <div
                  style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:23px;letter-spacing:-0.025em;color:#FFFFFF;")}
                >
                  Cary Smith
                </div>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:14px;letter-spacing:0.08em;text-transform:uppercase;color:#9EDBD1;margin-top:7px;")}
                >
                  Co-Founder & COO
                </div>
              </div>
            </div>
            <div style={s("padding:20px;flex:1;display:flex;flex-direction:column;")}>
              <div style={s("position:relative;")}>
                <p style={s("margin:0;font-size:15px;line-height:1.6;color:var(--paper-muted);")}>
                  A global finance veteran with 30+ years across E&Y, EarthLink, and JBoss, where as CFO he guided the company to its $370M acquisition by Red Hat.
                </p>
                <div
                  style={s(`position:absolute;top:100%;left:-21px;right:-21px;margin-top:10px;background:#FFFFFF;border:1px solid rgba(46,122,114,0.35);border-top:none;border-radius:0 0 20px 20px;box-shadow:0 22px 44px rgba(18,49,56,0.12);overflow:hidden;transition:max-height .45s cubic-bezier(.4,0,.2,1),opacity .3s ease;max-height:${v.bioMax3 ?? ""};opacity:${v.bioOp3 ?? ""};`)}
                >
                  <p
                    style={s("margin:0;padding:0 20px 20px;font-size:15px;line-height:1.6;color:var(--paper-muted);")}
                  >
                    Cary brings operational and financial discipline to make BrandBase secure, trusted, and built to last.
                  </p>
                </div>
              </div>
              <div
                style={s(`display:flex;align-items:center;gap:6px;margin-top:auto;overflow:hidden;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--paper-muted);transition:max-height .35s cubic-bezier(.4,0,.2,1),opacity .25s ease,padding-top .35s cubic-bezier(.4,0,.2,1);max-height:${v.cueH3 ?? ""};padding-top:${v.cuePad3 ?? ""};opacity:${v.cueOp3 ?? ""};`)}
              >
                {' '}
                <span>
                  {v.cueLabel3}
                </span>
                {' '}
                <span
                  style={s(`display:inline-block;transition:transform .35s ease;transform:${v.cueRot3 ?? ""};`)}
                >
                  ↓
                </span>
                {' '}
              </div>
            </div>
          </div>
          <div
            className="hv-14"
            onMouseEnter={v.teamOn4}
            onMouseLeave={v.teamOff}
            onClick={v.teamOn4}
            style={s("min-width:0;position:relative;z-index:1;height:100%;border-radius:20px;border:1px solid var(--paper-line);background:#FFFFFF;text-align:left;display:flex;flex-direction:column;transition:box-shadow .3s ease,border-color .3s ease;")}
          >
            <div
              style={s("position:relative;aspect-ratio:4/5;background:#E6EBE8;border-radius:19px 19px 0 0;overflow:hidden;")}
            >
              {' '}
              <img
                src="/assets/team-carson-rockett.webp"
                alt="Carson Rockett"
                style={s("position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;filter:grayscale(1) contrast(1.04);")}
              />
              {' '}
              <div
                style={s("position:absolute;inset:auto 0 0 0;padding:20px;background:linear-gradient(180deg,rgba(18,49,56,0) 0%,rgba(18,49,56,0.82) 68%);")}
              >
                <div
                  style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:23px;letter-spacing:-0.025em;color:#FFFFFF;")}
                >
                  Carson Rockett
                </div>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:14px;letter-spacing:0.08em;text-transform:uppercase;color:#9EDBD1;margin-top:7px;")}
                >
                  Co-Founder & CSO
                </div>
              </div>
            </div>
            <div style={s("padding:20px;flex:1;display:flex;flex-direction:column;")}>
              <div style={s("position:relative;")}>
                <p style={s("margin:0;font-size:15px;line-height:1.6;color:var(--paper-muted);")}>
                  A strategy and corporate development executive with prior roles at Liberty Mutual and Navigant Consulting, and an MBA from Duke's Fuqua School of Business.
                </p>
                <div
                  style={s(`position:absolute;top:100%;left:-21px;right:-21px;margin-top:10px;background:#FFFFFF;border:1px solid rgba(46,122,114,0.35);border-top:none;border-radius:0 0 20px 20px;box-shadow:0 22px 44px rgba(18,49,56,0.12);overflow:hidden;transition:max-height .45s cubic-bezier(.4,0,.2,1),opacity .3s ease;max-height:${v.bioMax4 ?? ""};opacity:${v.bioOp4 ?? ""};`)}
                >
                  <p
                    style={s("margin:0;padding:0 20px 20px;font-size:15px;line-height:1.6;color:var(--paper-muted);")}
                  >
                    Carson brings deep strategy and partnership experience to shape BrandBase's positioning, design partners, and path to market.
                  </p>
                </div>
              </div>
              <div
                style={s(`display:flex;align-items:center;gap:6px;margin-top:auto;overflow:hidden;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--paper-muted);transition:max-height .35s cubic-bezier(.4,0,.2,1),opacity .25s ease,padding-top .35s cubic-bezier(.4,0,.2,1);max-height:${v.cueH4 ?? ""};padding-top:${v.cuePad4 ?? ""};opacity:${v.cueOp4 ?? ""};`)}
              >
                {' '}
                <span>
                  {v.cueLabel4}
                </span>
                {' '}
                <span
                  style={s(`display:inline-block;transition:transform .35s ease;transform:${v.cueRot4 ?? ""};`)}
                >
                  ↓
                </span>
                {' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
